import { BASE_DOC_URL_VB } from 'app/developer-v3/constants';

export const CHECK_DESCRIPTIONS = {
  errors: 'Issues that will prevent your integration from functioning properly',
  activationTasks:
    'To-dos that must be addressed before your integration can be included in the App Directory',
  warnings: {
    private:
      'Issues and recommendations that will improve the quality of your integration',
    public:
      'Issues and recommendations that need to be reviewed by Zapier before publishing your integration',
  },
  passes: '',
};

export const VALIDATIONS_DOCS_URL = `${BASE_DOC_URL_VB}/publish/integration-checks-reference`;

export const SIDEBAR_TITLES = {
  summary: 'Validate',
  errors: 'Errors',
  activationTasks: 'Publishing tasks',
  warnings: 'Warnings',
};

export enum SECTIONS {
  SUMMARY = 'summary',
  ERRORS = 'errors',
  ACTIVATION_TASKS = 'activationTasks',
  WARNINGS = 'warnings',
}

export const PASSING_MESSAGE_LABELS = {
  errors: 'errors',
  activationTasks: 'publishing tasks',
  warnings: 'warnings',
  alerts: 'alerts',
};

export const VALIDATION_RESULT_GROUPINGS = {
  activationTasks: 'activationTasks',
  errors: 'errors',
  passes: 'passes',
  warnings: 'warnings',
};
